import gql from 'graphql-tag';
import fragments from './fragments';

const mutations = {};

mutations.login = gql`
  mutation loginUser($loginInput: LoginInput!) {
    login(loginInput: $loginInput) {
      user {
        ...appStateUserFields
      }
      ok
    }
  }

${fragments.appStateUserFields}`;

mutations.logout = gql`
  mutation logoutUser {
    logout {
      ok
    }
  }
`;

mutations.resetPassword = gql`
  mutation resetPassword($resetPasswordInput: ResetPasswordInput!){
    resetPassword(resetPassword: $resetPasswordInput){
      ok
    }
  }
`;

mutations.updateCampaign = gql`
  mutation updateCampaign($campaignInput: CampaignUpdateGenericType!) {
    updateCampaign(campaignInput: $campaignInput) {
      campaign {
        ...campaignFields
      }

      ok
      errors {
          messages
          field
      }
    }
  }

${fragments.campaignFields}`;

mutations.createCampaign = gql`
  mutation createCampaign($campaignInput: CampaignCreateGenericType!) {
      createCampaign(campaignInput: $campaignInput) {
      campaign {
        ...campaignFields
      }

      ok
        errors {
            messages
            field
        }
    }
  }

${fragments.campaignFields}`;

mutations.createImage = gql`
    mutation createImage ($input: ImageCreateGenericType!){
        createImage(input: $input) {
            image {
                url
                id
            }

            ok

            errors {
                field
                messages
            }
        }
    }
`;

mutations.registerRedeem = gql`
  mutation registerRedeem($couponId: ID!) {
      registerRedeem(couponId: $couponId) {
          ok
          errors {
              messages
              field
          }
      }
    }
`;

mutations.updateCoupon = gql`
  mutation updateCoupon($couponInput: CouponUpdateGenericType!) {
    updateCoupon(couponInput: $couponInput) {
      coupon {
        ...couponFields
      }

      ok
      errors {
          messages
          field
      }
    }
  }

${fragments.couponFields}`;

mutations.updateBeacon = gql`
  mutation updateBeacon($beaconInput: BeaconUpdateGenericType!) {
    updateBeacon(beaconInput: $beaconInput) {
      ok
      errors {
          messages
          field
      }
    }
  }
`;

mutations.saveCouponToDevice = gql`
  mutation saveCouponToDevice($input: SaveCouponToDeviceGenericType!) {
      saveCouponToDevice(input: $input) {
      ok
      errors {
          messages
          field
      }
    }
  }
`;

mutations.deleteCouponFromDevice = gql`
  mutation deleteCouponFromDevice($input: DeleteCouponFromDeviceGenericType!) {
    deleteCouponFromDevice(input: $input) {
      ok
      errors {
          messages
          field
      }
    }
  }
`;

mutations.createCoupon = gql`
  mutation createCoupon($couponInput: CouponCreateGenericType!) {
    createCoupon(couponInput: $couponInput) {
      coupon {
        ...couponFields
      }

      ok
      errors {
          messages
          field
      }
    }
  }

${fragments.couponFields}`;

mutations.inviteUser = gql`
  mutation inviteUser($inviteUserInput: InviteUserGenericType!) {
    inviteUser(inviteUser: $inviteUserInput) {
      ok
      errors {
          field
          messages
      }
    }
  }
`;

mutations.acceptInvite = gql`
  mutation acceptInvite($acceptInviteInput: AcceptInviteGenericType!) {
    acceptInvite(acceptInvite: $acceptInviteInput) {
      ok
      errors {
          field
          messages
      }
      user {
        ...appStateUserFields
      }
    }
  }

${fragments.appStateUserFields}`;

mutations.deleteCoupon = gql`
  mutation deleteCoupon($id: ID!) {
    deleteCoupon(id: $id) {
      ok
      errors {
          messages
          field
      }
    }
  }
`;

mutations.deleteUser = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      ok
      errors {
          messages
          field
      }
    }
  }
`;

mutations.editOrganization = gql`
  mutation editOrganization($input: UpdateOrganizationGenericType!){
    updateOrganization(input: $input) {
      organization {
        id
        subtitle
        name
        timezone
        city
        streetAddress
        postcode
        country
        currencySymbol
        currency {
          id
        }
      }
      ok
      errors {
          messages
          field
      }
    }
  }
`;

mutations.obtainJwt = gql`
  mutation getAccessToken($username: String!, $password: String!){
    obtainJwt(username: $username, password: $password) {
      token
      refreshToken
      refreshExpiresIn
      user {
        ...appStateUserFields
      }
    }
  }
${fragments.appStateUserFields}`;

mutations.refreshToken = gql`
  mutation refreshToken($refreshToken: String){
    refreshJwt(refreshToken: $refreshToken) {
      token
      refreshExpiresIn
    }
  }
`;

mutations.revokeRefreshToken = gql`
  mutation revokeRefreshToken($refreshToken: String){
    revokeJwt(refreshToken: $refreshToken) {
      revoked
    }
  }
`;

mutations.revokeRefreshToken = gql`
  mutation revokeRefreshToken($refreshToken: String){
    revokeJwt(refreshToken: $refreshToken) {
      revoked
    }
  }
`;


mutations.editProfile = gql`
  mutation editProfile($fullName: String!){
    editProfile( input: {fullName: $fullName}) {
      ok
      errors{
        field
        messages
      }
    }
  }
`;

mutations.signup = gql`
  mutation signup($input: RegisterOrganizationGenericType!){
    registerOrganization(input: $input) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

mutations.updateWatchTime = gql`
  mutation updateWatchTime($input: UpdateCouponWatchTimeGenericType!){
    updateCouponWatchTime(input: $input) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export default mutations;
